"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _common = require("../../utils/common");

var _common2 = _interopRequireDefault(_common);

var _constants = require("../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

var _env = require("../../utils/env");

var _env2 = _interopRequireDefault(_env);

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BusinessDetailsController = function () {
  function BusinessDetailsController($stateParams, $sce, BusinessesService, AppContextService, NotificationService, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, BusinessDetailsController);
    this.businessesService = BusinessesService;
    this.appContextService = AppContextService;
    console.log($stateParams.businessId);
    this.businessId = $stateParams.businessId;
    this.getBusinessDetails(this.businessId);
    this.deleteIntercomAccount = true;
    this.notificationService = NotificationService;
    this.$scope = $scope;
    this.$sce = $sce;
  }

  (0, _createClass3.default)(BusinessDetailsController, [{
    key: "$onInit",
    value: function $onInit() {
      this.tabTypes = {
        LEAD_DETAILS: 1,
        ACTIVITY: 2,
        NOTES: 3
      };
    }
  }, {
    key: "businessLink",
    value: function businessLink() {
      if (!this.business) return "";

      return 'https://www.jugglestreet.com.au/business-details?businessId=' + this.business.id;
    }
  }, {
    key: "locationStatus",
    value: function locationStatus() {
      if (!this.business) return '';

      return _constants2.default.getLocationStatusText(this.business.locationStatus);
    }
  }, {
    key: "locationType",
    value: function locationType() {
      if (!this.business) return '';

      return _constants2.default.getLocationTypeText(this.business.locationType);
    }
  }, {
    key: "getBusinessDetails",
    value: function getBusinessDetails(businessId) {
      var _this = this;

      this.isLoading = true;

      this.businessesService.getBusinessDetails(businessId, function (response) {
        _this.business = response.data;
        _this.isLoading = false;

        _this.getTabs();

        _this.$scope.$apply();
      }, function (error) {
        _this.isLoading = false;
      });
    }
  }, {
    key: "getTabs",
    value: function getTabs() {
      this.tabs = (0, _defineProperty3.default)({}, this.tabTypes.LEAD_DETAILS, {
        key: 1,
        label: "LEAD DETAILS",
        isActive: true,
        icon: "fa fa-user"
      });

      this.activeTab = this.tabs["1"];
    }
  }, {
    key: "switchTab",
    value: function switchTab(tab) {
      var _this2 = this;

      this.activeTab = tab;

      (0, _keys2.default)(this.tabs).map(function (i) {
        if (_this2.tabs[i] == _this2.activeTab) _this2.tabs[i].isActive = true;else _this2.tabs[i].isActive = false;
      });
    }
  }, {
    key: "formatDate",
    value: function formatDate(date) {
      return _common2.default.formatDate(date);
    }
  }, {
    key: "hasGlobalAdminAccess",
    value: function hasGlobalAdminAccess() {
      var appContext = this.appContextService.getAppContext();
      if (!appContext) return false;

      if (this.appContextService.hasGlobalAdminAccess(appContext.roles)) return true;else return false;
    }
  }, {
    key: "hasLoginAsUserAccess",
    value: function hasLoginAsUserAccess() {
      var appContext = this.appContextService.getAppContext();
      if (!appContext) return false;

      if (this.appContextService.hasLoginAsUserAccess(appContext.roles)) return true;else return false;
    }
  }, {
    key: "_getDialogOptions",
    value: function _getDialogOptions() {
      return {
        buttonLayout: "normal",
        messages: {
          close: ""
        },
        visible: false,
        closable: true,
        modal: true
      };
    }
  }, {
    key: "handleRefreshCache",
    value: function handleRefreshCache() {
      var _this3 = this;

      var payload = { actionType: _constants2.default.adminEntitiesActionType.REFRESH_CACHE };
      this.businessesService.updateUserDetails(this.businessId, payload, function () {
        _this3.notificationService.success("Cache refresh successful.");
      }, function () {
        _this3.notificationService.error("Cache refresh failed.");
      });
    }
  }]);
  return BusinessDetailsController;
}();

exports.default = BusinessDetailsController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/business-details/business-details.controller.js
 **/